import React from 'react';
import Timeago from 'react-timeago';
import moment from 'moment';
import 'moment-timezone';
import PropTypes from 'prop-types';

function TimeSince({ date, prefix = '' }) {
  let tz = moment.tz.guess();

  return (
    <Timeago
      date={moment.utc(date).tz(tz)}
      formatter={(value, unit, suffix, date) => {
        if (
          unit === 'day' ||
          unit === 'week' ||
          unit === 'month' ||
          unit === 'year'
        ) {
          function addZero(number) {
            if (number < 10) {
              number = '0' + number;
            }
            return number;
          }

          let d = new Date(date);
          let hours = addZero(d.getHours() % 12);
          let tod = addZero(d.getHours() > 12) ? 'PM' : 'AM';
          let minutes = addZero(d.getMinutes());

          if (value === 1 && unit !== 'year') {
            return `${prefix} Yesterday at ${hours}:${d.getMinutes()} ${tod}`.trim();
          } else {
            let now = new Date();

            let options = { month: 'long', day: '2-digit' };

            if (now.getYear() !== d.getYear()) {
              options = {
                month: 'long',
                day: '2-digit',
                year: 'numeric',
                minutes: '2-digit',
                seconds: '2-digit'
              };
            }

            let formatter = new Intl.DateTimeFormat('en', options);

            return `${prefix} ${formatter.format(
              d
            )} at ${hours}:${minutes} ${tod}`.trim();
          }
        }

        if (unit === 'second') {
          return 'posted just now';
        }
        if (value !== 1) {
          unit += 's';
        }

        return `${prefix} ${value} ${unit} ${suffix}`.trim();
      }}
    />
  );
}

TimeSince.propTypes = {
  date: PropTypes.string.isRequired,
  prefix: PropTypes.string
};

export default TimeSince;



// WEBPACK FOOTER //
// ./src/components/TimeSince/index.js